export function hasFilePickerSvgMarkup(file: any)
{
    return file.meta?.svg?.trim().length > 0;
}

export function isFilePickerSvg(file: any)
{
    const hasSvgContentType = (file.contentType ?? file.type)?.toLowerCase().split(';')[0].trim() === 'image/svg+xml';
    const hasSvgUrl = hasSvgExtension(file.url);
    const hasSvgName = hasSvgExtension(file.name);

    return hasSvgContentType || hasSvgUrl || hasSvgName;
}

export function isFilePickerIco(file: any)
{
    const contentType = (file.contentType ?? file.type)?.toLowerCase().split(';')[0].trim();

    return contentType === 'image/x-icon'
        || contentType === 'image/vnd.microsoft.icon'
        || hasIcoExtension(file.url)
        || hasIcoExtension(file.name);
}

export function isFilePickerImage(file: any, media: string)
{
    return file.isImage === true || (media === 'images' && Boolean(file.publicId));
}

export function isFilePickerImageProcessingAllowed(file: any)
{
    return !isFilePickerSvg(file) && !isFilePickerIco(file);
}

function hasSvgExtension(value: string)
{
    return value?.toLowerCase().split(/[?#]/)[0].endsWith('.svg') === true;
}

function hasIcoExtension(value: string)
{
    return value?.toLowerCase().split(/[?#]/)[0].endsWith('.ico') === true;
}

export function isFilePickerVideo(file: any)
{
    const type = String(file?.contentType ?? file?.type ?? '').toLowerCase();
    return type.startsWith('video/') || /\.(mp4|webm|ogv|mov|m4v)$/i.test(String(file?.name || file?.url || '').split(/[?#]/)[0]);
}

export function canPreviewFilePickerMedia(file: any)
{
    if (!file) return false;
    const type = String(file.contentType ?? file.type ?? '').toLowerCase();
    return file.isImage === true || type.startsWith('image/') || isFilePickerSvg(file) || isFilePickerIco(file) || isFilePickerVideo(file) || /\.(png|jpe?g|gif|webp|avif|bmp)$/i.test(String(file.name || file.url || '').split(/[?#]/)[0]);
}

export function filePickerPreviewKind(file: any): 'image' | 'video' | 'audio' | 'pdf' | 'file'
{
    if (isFilePickerVideo(file)) return 'video';
    const type = String(file?.contentType ?? file?.type ?? '').toLowerCase().split(';')[0].trim();
    if (type.startsWith('audio/')) return 'audio';
    if (type === 'application/pdf') return 'pdf';
    return canPreviewFilePickerMedia(file) ? 'image' : 'file';
}
